<template>
	<section class="Stats my-5">
		<div
			class="d-flex align-start justify-center gap-40 flex-wrap text-center"
		>
			<v-card class="statsGroup">
				<StatChip :value="totalLeads" label="Total" />
			</v-card>
			<v-card class="statsGroup">
				<StatChip :value="newLeads" label="New" />
			</v-card>
			<v-card class="statsGroup">
				<StatChip
					:value="totalAndTentative"
					label="Prospect + Tentative"
				/>
			</v-card>
			<v-card class="statsGroup">
				<StatChip
					:value="definiteLeads"
					label="Definite"
					color
					strong
				/>
			</v-card>
		</div>
	</section>
</template>

<script>
import StatChip from "@/components/StatChip";
import { STAT_FORMATS, LEAD_STATUSES, BUS_EVENTS } from "@/constants";
import { EventBus } from "@/utilities";
import { mapGetters, mapActions } from "vuex";

export default {
	name: "StatsOutbound",
	props: {
		dates: {
			type: Array,
			default() {
				return [];
			},
		},
		lead_id: {
			type: Number | String,
			default: null,
		},
	},
	data() {
		return {
			statFormats: STAT_FORMATS,
		};
	},
	computed: {
		...mapGetters({
			leads: "StateVisitors",
			totalLeads: "StateTotalVisitors",
			newLeads: "StateTotalNewVisitors",
		}),
		totalAndTentative() {
			return (
				this.leads.filter(
					(lead) =>
						lead.status === LEAD_STATUSES.PROSPECT ||
						lead.status === LEAD_STATUSES.TENTATIVE
				).length || 0
			);
		},
		definiteLeads() {
			return (
				this.leads.filter(
					(lead) => lead.status === LEAD_STATUSES.DEFINITE
				).length || 0
			);
		},
	},
	methods: {
		...mapActions(["getVisitors"]),
		async updateStats() {
			const showDashboard = await this.getVisitors({
				dates: this.dates,
				lead_id: this.lead_id,
			});
			if (!showDashboard) {
				this.$router.push("/select-property");
			}
		},
	},
	beforeMount() {
		this.updateStats();
		EventBus.$on(BUS_EVENTS.STATS_O_UPDATED, this.updateStats);
	},
	components: { StatChip },
};
</script>

<style lang="scss" scoped>
.Stats {
	.statsGroup {
		min-width: 160px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StatsOutbound.vue